import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ConfigurationItem100LicenseTab extends GenericListSearchTab {
    Bao = Bao;
    ConfigurationItem: any;
    constructor(tabPage: TabPage, parent?: any) {
        super(tabPage, parent);
        this.ConfigurationItem = parent;
    }
    ControllerUrl = "ConfigurationItem100LicenseTab";
    SearchType(): string {
        return "SoftwareLicence";
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        def.resolve(result);
        return def.promise();
    }
}
export default ConfigurationItem100LicenseTab;